const LogoutIcon = ({ color = "var(--pink)", size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.791 12.1211H9.75"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.8643 9.20508L21.7923 12.1211L18.8643 15.0371"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.3599 7.63C16.0299 4.05 14.6899 2.75 9.35986 2.75C2.25886 2.75 2.25886 5.06 2.25886 12C2.25886 18.94 2.25886 21.25 9.35986 21.25C14.6899 21.25 16.0299 19.95 16.3599 16.37"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default LogoutIcon;
